export const environment = {
  production: false,
  hostUrl: 'https://uat-kp-mm.vthgdigital.com',
  apiUrl: 'https://uat-kp-mm.vthgdigital.com/api/',
};
